import {
  POProductConfirmation,
  Product,
  ProductAmendment,
  ProductAmendmentInputField,
  POProductConfirmationInputField
} from "src/types";

export function splitByWarehouseRatio(amount: number, ukQty: number, euQty: number): { uk: number; eu: number };
export function splitByWarehouseRatio(
  amount: number | undefined,
  ukQty: number,
  euQty: number
): { uk: number | undefined; eu: number | undefined };
export function splitByWarehouseRatio(amount: number | undefined, ukQty: number, euQty: number) {
  if (amount === undefined) {
    return { uk: undefined, eu: undefined };
  }
  const total = ukQty + euQty;
  if (total === 0) {
    return { uk: amount, eu: 0 };
  }
  const uk = Math.floor(amount * (ukQty / total));
  return { uk, eu: amount - uk };
}

export const hasWarehouseSplit = (product: Pick<Product, "ukQuantity" | "euQuantity">): boolean => {
  return product.ukQuantity !== undefined || product.euQuantity !== undefined;
};

export const hasAnyWarehouseSplit = (products: Pick<Product, "ukQuantity" | "euQuantity">[]): boolean => {
  return products.some(hasWarehouseSplit);
};

export const calculateProductConfirmationFulfilmentRate = (
  poProductConfirmationsFormData: POProductConfirmationInputField[]
): number => {
  if (!poProductConfirmationsFormData || poProductConfirmationsFormData.length === 0) {
    return 0;
  }

  let totalOrderQty = 0;
  let totalConfirmedQty = 0;

  poProductConfirmationsFormData.forEach((product) => {
    const orderQty = parseFloat(product.orderQty) || 0;
    const confirmedQty = parseFloat(product.confirmedQty) || 0;

    totalOrderQty += orderQty;
    totalConfirmedQty += Math.min(confirmedQty, orderQty);
  });

  if (totalOrderQty === 0) {
    return 0;
  }

  return (totalConfirmedQty / totalOrderQty) * 100;
};

export const normaliseProductAmendmentInputField = (
  productAmendmentInputField: ProductAmendmentInputField
): ProductAmendment => {
  const { fieldId, amendedQty, orderQty, amendedUkQty, amendedEuQty, hasWarehouseSplit, ...product } =
    productAmendmentInputField;

  if (hasWarehouseSplit) {
    const ukQty = amendedUkQty ? Number(amendedUkQty) : 0;
    const euQty = amendedEuQty ? Number(amendedEuQty) : 0;
    return {
      ...product,
      quantity: ukQty + euQty,
      ukQuantity: ukQty,
      euQuantity: euQty
    };
  }

  return {
    ...product,
    quantity: amendedQty ? Number(amendedQty) : undefined
  };
};

export const normaliseProductConfirmationInputField = (
  poProductConfirmationInputField: POProductConfirmationInputField
): POProductConfirmation => {
  const { fieldId, confirmedQty, estRestockDate, isDiscontinued, ...rest } = poProductConfirmationInputField;

  return {
    ...rest,
    confirmedQty: Number(confirmedQty),
    estRestockDate: estRestockDate || undefined,
    isDiscontinued: isDiscontinued || false
  };
};
